import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import FileInput from './FileInput';


function FileUploadDemo() {

  return (
    <Container>
      <Container className="mt-10">
        <Row>
          <Col className="mt-10 p-0">
            <h4>File Upload</h4>
            <Container className="d-flex justify-content-between flex-wrap mt-10 p-0">
              <FileInput placeholder={'filename.pdf'} label={'Sample label'} className="mw-100 mr-2" width="420px"/>
            </Container>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default FileUploadDemo;
